import React from "react";
import "./style.scss";
import Icon01 from "assets/images/svg/connect-cards-icons01.svg";
import Icon02 from "assets/images/svg/connect-cards-icons02.svg";
import Icon03 from "assets/images/svg/connect-cards-icons03.svg";
import Icon04 from "assets/images/svg/connect-cards-icons04.svg";

const cardData = [
  {
    icon: Icon01,
    title: "Profiles you can trust",
    text: "Authentic and manually verified profiles for secure matchmaking.",
  },
  {
    icon: Icon02,
    title: "Easy & smart matchmaking",
    text: "AI-powered suggestions based on compatibility.",
  },
  {
    icon: Icon03,
    title: "Matches beyond all borders",
    text: "Connect with Malayali singles across India & abroad.",
  },
  {
    icon: Icon04,
    title: "Personalized assistance",
    text: "Dedicated support for premium users.",
  },
];

function ConnectCards() {
  return (
    <div className="connect-cards-container">
      {cardData.map((item, index) => (
        <div className="connect-cards-wrapper" key={index}>
          <span className="card-icon">
            <img src={item.icon} alt="icon" />
          </span>
          <div className="card-content-container">
            <span
              className={`font-title-lg fw-700  ${index === 2 ? "limited-width" : ""}`}
            >
              {item.title}
            </span>
            <p className="content font-title-sm">{item.text}</p>
          </div>
        </div>
      ))}
    </div>
  );
}

export default ConnectCards;
